// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2-gMH","requiredAsterisk":"Info_requiredAsterisk__8TILM"};